import {
  Checkbox,
  CheckboxField,
  CheckboxGroup,
  Label,
} from "@a7y/tailwind-catalyst";

interface StageOption<T extends string> {
  value: T;
  label: string;
}

interface LifecycleStageCheckboxGroupProps<T extends string> {
  legend: string;
  options: StageOption<T>[];
  selected: T[];
  onChange: (selected: T[]) => void;
}

/**
 * Shared checkbox group for selecting lifecycle/billing stages.
 * Used by Announcements (OrgBillingStatus) and Learning Topics (LifecycleStage).
 */
export function LifecycleStageCheckboxGroup<T extends string>({
  legend,
  options,
  selected,
  onChange,
}: LifecycleStageCheckboxGroupProps<T>) {
  const toggle = (value: T) => {
    onChange(
      selected.includes(value)
        ? selected.filter((s) => s !== value)
        : [...selected, value]
    );
  };

  return (
    <fieldset>
      <legend className="text-sm font-medium text-zinc-950 dark:text-white">
        {legend}
      </legend>
      <CheckboxGroup className="mt-3">
        {options.map((opt) => (
          <CheckboxField key={opt.value}>
            <Checkbox
              checked={selected.includes(opt.value)}
              onChange={() => toggle(opt.value)}
              color="blue"
            />
            <Label>{opt.label}</Label>
          </CheckboxField>
        ))}
      </CheckboxGroup>
    </fieldset>
  );
}
